export enum ForgottenTimeEntryContextDispatchActionType {
	SetModalTimeEntry,
}
